export default country => {
  switch (country) {
    case 'ae':
      return 'د.إ'
    case 'gb':
      return '£'
    case 'hk':
      return 'HK$'
    case 'ie':
      return '€'
    case 'za':
      return 'R'
    default:
      return '$'
  }
}
